<template>
  <div :class="$style.reveive">
    <div :class="$style.brief">
      <div :class="$style.text">
        <span>总奖金</span>
        <span>总奖金</span>
      </div>
      <!-- 奖金金额 -->
      <div>
        <div :class="$style.text">
          <span>{{ receive_info.activity_money }}元</span>
          <span>{{ receive_info.activity_money }}元</span>
        </div>
      </div>
      <button :class="$style.rule" @click="redirectRule">
        <span>活动规则</span>
        <i :class="`iconfont yw-xiangyou ${$style.leaveFor}`"></i>
      </button>
      <button :class="$style.condition" @click="redirectCondition">
        <span>领取条件</span>
        <i :class="`iconfont yw-xiangyou ${$style.leaveFor}`"></i>
      </button>
      <span :class="$style.countdown" v-if="countdown">仅剩 {{ countdownTransfer }}</span>
    </div>
    <!-- 跑马灯 -->
    <div :class="$style.marquee">
      <div :class="$style.view">
        <div :class="$style.cont">
          <p :class="$style.run" v-for="(item, index) in marqueeList" :key="index">
            {{ `恭喜玩家 ${item.text} 成功提现${item.money}元` }}
          </p>
        </div>
      </div>
    </div>
    <!-- tab栏 -->
    <div :class="$style.typeList">
      <span
        v-for="item in filterTypeList"
        :key="item.type"
        :class="[activeTab === item.type ? $style.active : '', item.hint ? $style.hint : '']"
        @click="changeTab(item.type)"
        >{{ item.text }}</span
      >
    </div>
    <div :class="$style.bonusList">
      <div v-for="(item, index) in filterPackets" :key="index" :class="$style.bonusItem">
        <div :class="$style.content">
          <img :src="handleIcon(item.typeId)" alt />
          <div>
            <div :class="$style.minTitle">
              <span :class="$style.count" v-if="!!item.name">{{ item.name }}</span>
              <span :class="$style.count" v-else>
                活动奖金
                <span>{{ handlePrice(item) }}元</span>
              </span>
            </div>
            <p :class="$style.lightning" v-if="item.flash == 1">闪电提现</p>
            <p>{{ handleTitle(item) }}</p>
            <p v-if="!!item.name" :class="$style.reward">
              <span>{{ handlePrice(item) }}元</span>现金红包
            </p>
          </div>
        </div>
        <div :class="$style.operate">
          <button :class="`${$style.receiveBtn} ${$style['type-' + item.apply_status]}`" @click="getReceive(item)">
            {{ getBtnText(item.apply_status) }}
          </button>
          <!-- 除支付无限制时间情况都显示 -->
          <p :class="$style.limit" v-if="!(item.conditionType == 2 && !item.role_create_begin && !item.role_created_end)">
            {{ handleLimitThreshold(item) }}
          </p>
        </div>
      </div>
    </div>
    <img :src="`${$cdnLink}/red-envelope/wallet2.png`" alt="" :class="$style.walletImg" @click="toWallet" />
    <transition name="fade">
      <ReceiveToast
        v-if="receiveToastVisible"
        :money="toastMoney"
        :step="receiveToastStep"
        @close="receiveToastVisible = false"
        @openWallet="toWallet"
        @receive="receivePacket"
      ></ReceiveToast>
    </transition>
    <!-- <Bind :fullScreenFlag="true" v-if="bindShow" @back="bindShow = false"></Bind> -->
  </div>
</template>

<script>
import { isSysName, sort_ASCII, randomN } from '@/libs/utils';
import { mapActions, mapState, mapMutations } from 'vuex';
import ReceiveToast from './ReceiveToast';
import Bind from '@/components/login/BindPhone';
import { getReceive, getReceiveV2, getWithdrawOptions, getWithdrawOptionsV3 } from '@/api/activity';
import { handlePrice } from '@/libs/business/red-envelope';
import moment from 'moment';
import _ from 'lodash';
export default {
  name: '',
  data() {
    return {
      flag: false, // 防止领取并发
      activeTab: '',
      receiveToastVisible: false,
      toastMoney: '',
      receiveToastStep: 0,
      currentPacket: {},
      bindShow: false,
      // 跑马灯数组
      marqueeList: [],
      marqueeMoney: [],
      countdown: '',
      countdownTransfer: '',
      countdownInterval: null,
    };
  },
  created() {
    this.getWithdrawOptions();
  },
  async mounted() {
    this.getReceiveInfo();
    if (this.typeList.length) this.activeTab = this.typeList[0].type;
  },
  computed: {
    ...mapState({
      typeList: (state) => state.redEnvelope.typeList,
      packets: (state) => state.redEnvelope.packets,
      receive_info: (state) => state.redEnvelope.receive_info,
      appkey: (state) => state.user.appkey,
      user_id: (state) => state.user.user_id,
      tel_status: (state) => state.user.tel_status,
      bridgeInitFlag: (state) => state.redEnvelope.bridgeInitFlag,
      role: (state) => state.redEnvelope.role,
    }),
    filterPackets() {
      if (!this.typeList.length) return [];
      return this.packets[this.activeTab];
    },
    filterTypeList() {
      let typeList = this.typeList;
      let suspendTabHint = false;
      typeList = typeList.map((typeItem, typeIndex) => {
        let packets = this.packets[typeItem.type];
        let isHint = packets.find((packet) => packet.apply_status == 1);
        if (isHint) suspendTabHint = true;
        return {
          ...typeItem,
          hint: !!isHint,
        };
      });
      if (suspendTabHint) {
        this.$setStorage('welfareTabHint', true); // 此处缓存用于下次首次打开悬浮窗时候判断是否显示红点，避免用重复接口请求去判断
        this.$store.commit('suspend/SET_TAB_HINT', { tabType: 'welfare', hintType: true });
      } else {
        this.$setStorage('welfareTabHint', false);
        this.$store.commit('suspend/SET_TAB_HINT', { tabType: 'welfare', hintType: false });
      }
      return typeList;
    },
  },
  watch: {
    typeList() {
      if (this.typeList.length) this.activeTab = this.typeList[0].type;
    },
  },
  methods: {
    ...mapActions(['redEnvelope/getReceiveInfo', 'user/getBaseInfo', 'global/openCustomer']),
    ...mapMutations(['redEnvelope/CHANGE_STATE']),
    changeTab(type) {
      this.activeTab = type;
    },
    // 处理每个规则的标题显示
    handleTitle(packet) {
      const sub_conditions = _.cloneDeep(packet.sub_conditions);
      let str = '';
      sub_conditions.sort((a, b) => {
        if (a.condition_type == 4) {
          return -1;
        } else if (a.condition_type < b.condition_type) {
          return -1
        }else {
          return 1
        }
      });
      sub_conditions.map((item) => {
        str += `${this.handleDate(item)}${this.handleConditionType(item.condition_type, item.value_type)}${this.handleOperator(item.relationship)}${
          item.threshold || item.condition_value
        }${this.handleConditionUnit(item.condition_type)}且`;      
      });
      str = str.substring(0, str.length - 1);
      return str;
    },
    // 处理运算符
    handleOperator(operator) {
      switch (operator) {
        case '>':
          return '超过';
        case '=':
          return '';
        default:
          return '达到';
      }
    },
    // 处理规则类型
    handleConditionType(conditionType, valueType) {
      switch (conditionType) {
        case 1:
          return '等级';
        case 2:
          return valueType == 1 ? '单笔充值' : '累计充值';
        case 4:
          return valueType == 1 ? '连续登录' : '累计登录';
      }
    },
    handleDate(item) {
      if (item.role_create_begin == 0 && item.role_created_end == 0) return '';
      if (!item.role_create_begin || !item.role_created_end) return '';
      if (item.role_create_begin == item.role_created_end) return `创角第${item.role_create_begin}日`;
      return `创角第${item.role_create_begin}日-第${item.role_created_end}日`;
    },

    // 1等级 2充值（角色的充值） 3战力 4其他（同时拥有两种或两种不同条件类型限制以上归为其他）
    handleIcon(type) {
      return `${this.$cdnLink}/red-envelope/v2/icon.png`;
      // switch(type) {
      //   case 1:
      //     return `${this.$cdnLink}/red-envelope/ct_1.png`;
      //   case 2:
      //     return `${this.$cdnLink}/red-envelope/ct_2.png`;
      //   case 3:
      //     return `${this.$cdnLink}/red-envelope/ct_3.png`;
      //   case 4:
      //     return `${this.$cdnLink}/red-envelope/ct_4.png`;
      // }
    },
    // 处理规则类型
    handleConditionUnit(conditionType) {
      switch (conditionType) {
        case 1:
          return '级';
        case 2:
          return '元';
        case 4:
          return '天';
        default:
          return '';
      }
    },
    handleLimitThreshold(item) { 
      return  `创角${item.limit_threshold}日内完成`
    },
    handlePrice(packet) {
      return handlePrice(packet);
    },
    // 获取领取页信息
    async getReceiveInfo() {
      await this['redEnvelope/getReceiveInfo']({
        params: {
          appkey: this.appkey,
          user_id: this.user_id,
          server_num: this.role.server_num,
          role_id: this.role.role_id,
        },
        fail: () => this.$toast('红包信息获取失败'),
      });
      this.setCountDown();
    },
    // 点击领取按钮
    getReceive(item) {
      const { apply_status, rule_key } = item;
      // 领取状态为2时才能领取
      if (apply_status != 1) return;
      // 未绑定手机
      // if (this.tel_status == 0) {
      //   this.bindShow = true;
      //   return;
      // }
      // 已经点过领取按钮
      if (this.flag) return;
      this.flag = true;

      // 打开领取界面
      this.receiveToastVisible = true;
      this.receiveToastStep = 0;
      this.currentPacket = item;
    },
    async receivePacket() {
      try {
        let r = null;
        if (this.receive_info.version == 2) {
          r = await getReceiveV2({
            appkey: this.appkey,
            user_id: this.user_id,
            server: this.role.server_num,
            role_id: this.role.role_id,
            role_name: this.role.role_id,
            server_name: this.role.server_name,
            sub_rule_id: this.currentPacket.sub_rule_id,
          });
        } else {
          r = await getReceive({
            appkey: this.appkey,
            user_id: this.user_id,
            server_num: this.role.server_num,
            role_id: this.role.role_id,
            rule_key: this.currentPacket.rule_key,
          });
        }
        this.toastMoney = r.content.money;
        this.receiveToastVisible = true;
        this.currentPacket.apply_status = 2;
        this.receiveToastStep = 1;
      } catch (error) {}
      this.flag = false;
    },
    back() {
      window.WebViewJavascriptBridge && window.WebViewJavascriptBridge.callHandler('registReturnGameFunction', null, function (response) {});
    },  
    getBtnText(status) {
      switch (status) {
        case 0:
          return '未满足';
        case 1:
          return '领取';
        case 2:
          return '已领取';
        case 3:
          return '已超时';
        default:
          return '领取';
      }
    }, 
    redirectCondition() {
      this.$emit('setPage', 'condition');
    },
    redirectRule() {
      this.$emit('setPage', 'rule');
    },
    openCustomer() {
      this['global/openCustomer']();
    },
    toWallet() {
      this.receiveToastVisible = false;
      this.$emit('setPage', 'wallet');
    },
    // 处理倒计时
    setCountDown() {
      this.countdown = this.countdown || this.receive_info.countdown;
      if (this.countdown) {
        let d = moment.duration(this.countdown, 'seconds');
        this.countdownTransfer = Math.floor(d.asDays()) + '天' + d.hours() + ':' + d.minutes() + ':' + d.seconds();
        this.countdownInterval = setInterval(() => {
          this.countdown = this.countdown - 1;
          let d = moment.duration(this.countdown, 'seconds');
          this.countdownTransfer =
            Math.floor(d.asDays()) +
            '天' +
            (d.hours() < 10 ? `0${d.hours()}` : d.hours()) +
            ':' +
            (d.minutes() < 10 ? `0${d.minutes()}` : d.minutes()) +
            ':' +
            (d.seconds() < 10 ? `0${d.seconds()}` : d.seconds());
        }, 1000);
      }
    },
    async getWithdrawOptions() {
      let r = null;
      if (this.receive_info.version == 1) {
        r = await getWithdrawOptions({
          appkey: this.appkey,
        });
        if (r.content.length) {
          this.marqueeMoney = r.content.map((item) => {
            return {
              label: `${item}元`,
              value: item,
            };
          });
        }
      } else {
        r = await getWithdrawOptionsV3({
          user_id: this.user_id,
          role_id: this.role.role_id,
        });
        this.marqueeMoney = r.content.option_list.map((item) => {
          return {
            label: `${item.money}元`,
            value: item.money,
          };
        });
      }
      this.random8();
    },
    random8() {
      for (let i = 0; i < 8; i++) {
        let s = randomN(8);
        // 获取红包列表随机一个 money
        let len = this.marqueeMoney.length;
        let r = Math.floor(Math.random() * len);
        let obj = { text: s, money: this.marqueeMoney[r]['value'] };
        this.marqueeList.push(obj);
      }
    },
  },
  components: {
    ReceiveToast,
    // Bind,
  },
  beforeDestroy() {
    this.countdownInterval && clearInterval(this.countdownInterval);
  },
};
</script>

<style lang="scss" module>
$font-lg: 15px;
$font-nm: 12px;
$font-sm: 9px;

.zIndex {
  position: relative;
  z-index: 1;
}
.resetBtn {
  background-color: transparent;
  border: none;
  outline: none;
}
.btnActive {
  &:active {
    -webkit-filter: brightness(110%);
    filter: brightness(110%);
  }
}

.reveive {
  background: #ffffff;
  position: relative;
  overflow-y: auto;
  height: 100%;
  &::-webkit-scrollbar {
    display: none;
  }
  .brief {
    // width: 312px;
    height: 62px;
    margin: 0 20px;
    background: url('//sdk-static.zhangyuqu.com/Lianyun/SdkImg/red-envelope/v2/banner2.png') no-repeat;
    background-size: 100% 100%;
    position: relative;
    // margin: auto;
    padding-top: 8px;
    text-align: center;
    font-size: 20px;
    .text {
      display: inline-block;
      margin: auto;
      font-weight: bold;
      position: relative;
      margin-bottom: 4px;
      letter-spacing: 2px;
      > span:nth-child(1) {
        background: -webkit-linear-gradient(90deg, #fffdbf 0%, #ffffff 80%);
        -webkit-background-clip: text;
        color: transparent;
      }
      > span:nth-child(2) {
        position: absolute;
        left: 0px;
        z-index: 1;
        color: #fffdbf;
        text-shadow: 0px 0px 2px #f44713, 0px 2px 2px #8e0707;
      }
    }
    .condition {
      @extend .zIndex;
      @extend .resetBtn;
      font-size: 0;
      background: #ffffff;
      border-radius: 30px 0 0 30px;
      padding: 5px 6px 4px 8px;
      color: #d05c47;
      display: flex;
      align-items: center;
      position: absolute;
      bottom: 4px;
      right: 0;
      @extend .btnActive;
      > span,
      > i {
        display: inline-block;
        font-size: $font-sm;
        vertical-align: bottom;
      }
      > i {
        font-size: 8px;
      }
    }
    .countdown {
      @extend .zIndex;
      font-size: 10px;
      position: absolute;
      bottom: 8px;
      left: 5px;
      color: #ffffff;
    }
    .rule {
      @extend .condition;
      position: absolute;
      bottom: 26px;
    }
  }
  .marquee {
    width: 100%;
    height: 20px;
    padding: 0px 20px;
    font-size: 12px;
    line-height: 20px;
    margin-top: 4px;
    .view {
      width: 100%;
      height: 100%;
      overflow: hidden;
      position: relative;
      border-radius: 2px;
      background-color: rgba(254, 109, 71, 0.8);
      .cont {
        width: 2200px;
        height: 100%;
        position: absolute;
        left: 0;
        display: flex;
        animation: marquee 30s linear infinite;
        .run {
          color: #fffdbf;
          width: 220px;
          height: 100%;
        }
      }
    }
  }
  @keyframes marquee {
    0% {
      left: 0;
    }
    100% {
      left: -2000px;
    }
  }
  .typeList {
    padding-left: 20px;
    margin-top: 4px;
    > span {
      color: #8a8989;
      font-size: 9.5px;
      display: inline-block;
      border: 1px solid #b2b2b2;
      text-align: center;
      line-height: 18px;
      border-radius: 3px;
      padding: 0 10px;
      margin-right: 5px;
      position: relative;
      &.active {
        color: #ff0000;
        border-color: #ff0000;
      }
      &.hint {
        &:before {
          position: absolute;
          content: ' ';
          top: -3px;
          right: -3px;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: red;
        }
      }
    }
  }
  .bonusList {
    padding: 8px 20px 5px;
    color: #121212;
    font-weight: 400;
    margin-bottom: 0px;
    height: calc(100% - 110px);
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 0px;
      height: 0px;
    }
    &::-webkit-scrollbar-track {
      background: rgb(239, 239, 239);
      border-radius: 10px;
      padding: 0;
    }
    &::-webkit-scrollbar-thumb {
      background: #bfbfbf;
      border-radius: 10px;
      padding: 0;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: #333;
    }
    .bonusItem {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 2px;
      font-size: 0;
      .content {
        display: flex;
        align-items: center;
        > img {
          display: inline-block;
          width: 36px;
          height: 36px;
          margin-right: 4px;
          margin-top: -4px;
        }
        > div {
          margin-bottom: 5px;
          .minTitle {
            font-size: 12px;
            display: flex;
            .count {
              flex: none;
              display: inline-block;
              vertical-align: middle;
              margin-right: 4px;
              font-weight: 700;
              font-size: 10px;
              max-width: 190px;
              > span {
                color: #ff8b23;
              }
            }
          }
          .lightning {
            width: 40px;
            line-height: 12px;
            margin: 2px 0;
            text-align: center;
            background: linear-gradient(90deg, #fcf296 0%, #fee76e 36%, #fee565 68%, #ffd944 100%);
            border-radius: 2.25px;
            color: #84441a;
            font-size: 8px;
          }
          > p {
            font-size: 9px;
            line-height: 13px;
            color: #707070;
            > span {
              color: #fd3737;
            }
          }
          .reward {
            font-weight: 700;
            color: #000000;
            font-size: 10px;
          }
        }
        
      }
      .operate {
        flex: none;
        // width: 76px;
        .receiveBtn {
          @extend .resetBtn;
          width: 70px;
          box-sizing: border-box;
          // height: 0.46rem;
          padding: 5px 0 4px;
          background: rgba(155, 155, 155, 1);
          border-radius: 12px;
          font-size: 12px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #ffffff;
          margin-bottom: 5px;
          &.type-1 {
            background: #ff5b58;
            @extend .btnActive;
          }
        }
        .limit {
          background: #f9f1f1;
          font-size: 8px;
          line-height: 12px;
          color: #e38313;
          display: flex;
          align-items: center;
          padding: 0 6px;
          border-radius: 12px;
        }
      }
    }
  }
  .walletImg {
    position: absolute;
    top: 160px;
    right: 5px;
    width: 45px;
    height: 45px;
    display: inline-block;
    &:active {
      -webkit-filter: brightness(110%);
      filter: brightness(110%);
    }
  }
}
</style>
